/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

function ProtectedRoute({ component: Component, ...rest }) {
  const authToken = useSelector(({ auth }) => auth.token);

  const trialMode = useSelector((state) => state.auth.mode);

  return (
    <Route
      {...rest}
      render={(props) =>
        authToken && !trialMode ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/',
            }}
          />
        )
      }
    />
  );
}

export default ProtectedRoute;
